export const PRESET_DEVICE_TYPES = ['amplifier', 'synthesizer', 'effect', 'mixer', 'other']
export const CUSTOM_DEVICE_TYPE_VALUE = 'custom'

export function isPresetDeviceType(value) {
  return PRESET_DEVICE_TYPES.includes((value || '').trim())
}

export function splitDeviceTypeForForm(deviceType) {
  const trimmed = (deviceType || '').trim()
  if (!trimmed) return { select: '', custom: '' }
  if (isPresetDeviceType(trimmed)) return { select: trimmed, custom: '' }
  return { select: CUSTOM_DEVICE_TYPE_VALUE, custom: trimmed }
}

export function resolveDeviceTypeForMetadata(selectValue, customValue) {
  if (selectValue === CUSTOM_DEVICE_TYPE_VALUE) {
    return (customValue || '').trim()
  }
  return (selectValue || '').trim()
}

/** Prefer a custom label stored in category when device_type is the generic "other" enum. */
export function getDeviceTypeLabel(repo) {
  if (!repo) return ''
  if (repo.device_type === 'other' && repo.category) {
    return repo.category
  }
  return repo.device_type || ''
}
